import Vue from 'vue'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

import {
  Dialog,
  Option,
  Button,
  Select,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  InputNumber,
  Message,
  Radio,
  RadioGroup,
  Checkbox,
  DatePicker,
  Progress,
  Row,
  Form,
  Tabs,
  TabPane,
  Badge,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Cascader,
  CheckboxGroup,
  FormItem,
  Pagination,
  Tooltip,
  Rate,
  Autocomplete,
  Table,
  Popover,
  TableColumn,
  CascaderPanel,
  Loading
} from 'element-ui'

export default () => {
  Vue.use(Dialog)
  Vue.use(Option)
  Vue.use(Button)
  Vue.use(Select)
  Vue.use(Menu)
  Vue.use(Submenu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Input)
  Vue.use(InputNumber)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(Checkbox)
  Vue.use(DatePicker)
  Vue.use(Progress)
  Vue.use(Row)
  Vue.use(Form)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Badge)
  Vue.use(Steps)
  Vue.use(Step)
  Vue.use(Carousel)
  Vue.use(CarouselItem)
  Vue.use(Cascader)
  Vue.use(CheckboxGroup)
  Vue.use(FormItem)
  Vue.use(Tooltip)
  Vue.use(Rate)
  Vue.use(Autocomplete)
  Vue.use(Pagination)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Popover)
  Vue.use(CascaderPanel)
  // Vue.use(MessageBox)

  Vue.use(Loading.directive)

  Vue.prototype.$message = Message
}

Vue.component(CollapseTransition.name, CollapseTransition)



// WEBPACK FOOTER //
// ./src/assets/utils/elementJs.js